import { B2CPolicy } from 'src/app/core/constants/btc-policies';
import { IEnvironmentVariables } from './IEnvironment';

const authorityBaseUrl = 'https://mncportaldev.b2clogin.com/tfp/mncportaldev.onmicrosoft.com';

const API_URL = {
  Platform: 'https://api-platform.portaldev.mynexuscare.com',
  RR: 'https://api-resourcerouter.portaldev.mynexuscare.com',
};

const consentScopes = [
  'https://mncportaldev.onmicrosoft.com/api/api.Write',
  'https://mncportaldev.onmicrosoft.com/api/api.Read',
  'https://mncportaldev.onmicrosoft.com/api/user_impersonation',
];

export const environment: IEnvironmentVariables = {
  production: false,
  authConfig: {
    config: {
      auth: {
        authority: `${authorityBaseUrl}/${B2CPolicy.SignUpSignIn}`,
        clientId: 'fe9425ee-f357-42b9-829f-ba2f5e4fc23c',
        knownAuthorities: ['mncportaldev.b2clogin.com'],
        postLogoutRedirectUri: 'https://resourcerouter.portaldev.mynexuscare.com/login',
        redirectUri: 'https://resourcerouter.portaldev.mynexuscare.com/login',
      },
    },
    angularConfig: {
      consentScopes,
      protectedResourceMap: Object.values(API_URL).map((url) => [url, consentScopes]),
    },
  },
  authorityBaseUrl,
  api: API_URL,
};
